<template>
    <div>
        <v-card color="white" elevation="0" class="d-flex align-content-end" width="100%" style="border: none; box-shadow: none;">
            <v-card-text style="color: black;">
                <v-row justify="center" align="center">
                    <v-col cols="11">
                        <v-row>
                            <v-col cols="2" md="2" sm="2">
                                <v-img src="../../../assets/background/Kings_international_3308.jpg" width="100%" contain></v-img>
                            </v-col>
                            <v-col cols="10" md="10" sm="10" class="d-flex align-center">
                                <span>
                                    <span class="text-h4">PART-TIME FACULTY APPOINTMENTS</span><br />
                                    <b>These work assignments are posted and filled in accordance with the Collective Agreement between King's University College and CUPE 5265.</b>
                                </span>
                            </v-col>
                            <v-col cols="12" md="12" class="text-h5">{{ resolveGeneralTerm }} Term</v-col>
                            <v-col cols="12" md="12" v-if="resolveType">
                                The following courses are being posted as a multi-section/course position as per Article 12.05 of the Collective Agreement. 
                                The successful candidate must accept the position in its entirety.
                            </v-col>
                            <v-col cols="12" md="12">
                                <span class="text-h6">
                                    Academic Unit: {{ item.department }}<br />
                                    {{ item["subject-resolved"] }} - {{ item.type }} Posting
                                </span>
                            </v-col>
                        </v-row>
                        <v-simple-table style="width: 100%; border-collapse: collapse;" dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th rowspan="2">Term</th>
                                        <th rowspan="2">Section</th>
                                        <th rowspan="2">Class Format</th>
                                        <th rowspan="2">Catalog</th>
                                        <th rowspan="2">Name</th>
                                        <th rowspan="2">Component</th>
                                        <th rowspan="2">Approx. Size</th>
                                        <th colspan="5" style="text-align: center;">Days</th>
                                        <th rowspan="2">Start Date</th>
                                        <th rowspan="2">End Date</th>
                                        <th rowspan="2">Time</th>
                                    </tr>
                                    <tr>
                                        <th>Mon</th>
                                        <th>Tue</th>
                                        <th>Wed</th>
                                        <th>Thu</th>
                                        <th>Fri</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="course in item.courses" :key="course.classnbr">
                                        <td>{{ resolveTerm(course.sessioncode) }}</td>
                                        <td>{{ course.classsection }}</td>
                                        <td>{{ course.classformat }}</td>
                                        <td>{{ course.catalognbr }}</td>
                                        <td>{{ course.descr }}</td>
                                        <td>{{ course.ssrcomponent }}</td>
                                        <td>{{ course.enrlcap }}</td>
                                        <td><v-checkbox v-model="course.mon" disabled true-value="Mon"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.tues" disabled true-value="Tue"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.wed" disabled true-value="Wed"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.thurs" disabled true-value="Thu"></v-checkbox></td>
                                        <td><v-checkbox v-model="course.fri" disabled true-value="Fri"></v-checkbox></td>
                                        <td>{{ course.instructionstart }}</td>
                                        <td>{{ course.instructionend }}</td>
                                        <td>{{ course.starttime }}-{{ course.endtime }}</td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
                <v-row justify="center" align="center">
                    <v-col cols="11">
                        <v-card elevation="0" style="border: none; box-shadow: none;">
                            <v-simple-table style="width: 90%;">
                                <template v-slot:default>
                                    <tbody>
                                        <tr>
                                            <td style="width: 20%;">Application Deadline</td>
                                            <td>{{ item.endDate }}</td>
                                        </tr>
                                        <tr v-if="resolveType">
                                            <td style="width: 20%;">Salary</td>
                                            <td>${{ item.salary }}</td>
                                        </tr>
                                        <tr>
                                            <td style="width: 20%;">Notes</td>
                                            <td style="white-space: pre-line;">{{ item.notes }}</td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table><br />
                            <div>
                                This posting is for an existing vacancy.
                            </div><br />
                            <div>
                                <span class="text-h6">Qualifications</span><br/>
                                <p style="white-space: pre-line;">
                                    {{ item.qualifications.split("Academic Calendar")[0] }}<a href="https://www.westerncalendar.uwo.ca/Courses.cfm?SelectedCalendar=Live&ArchiveID=" target="_blank">Academic Calendar</a>{{ item.qualifications.split("Academic Calendar")[1] }}
                                </p>
                            </div><br />
                            <div>
                                <span class="text-h6">Responsibilities</span><br/>
                                <p>
                                    Your responsibilities include, but are not limited to course preparation/materials; 
                                    classroom/laboratory instruction; setting and marking all graded course components (tests, assignments, etc.); 
                                    meeting with students (office hours); classroom management, proctoring tests/examinations; 
                                    and the resolution of student appeals related to this work assignment (Article 12.04). 
                                    The carrying out of these responsibilities may need to take place preceding and/or following the period of instruction in matters such as but not limited to preparation of course syllabi, 
                                    marking and grading of exams and assignments, and fulfilling instructor obligations as set out by university policy related to student appeals and academic offences. 
                                </p>
                            </div><br />
                            <div v-if="!resolveType">
                                <span class="text-h6">Salary</span><br/>
                                <p>
                                    <v-simple-table style="width: 100%; border-collapse: collapse;">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>Effective Date as of May 1</th>
                                                    <th>0.5 Course Load</th>
                                                    <th>1.0 Course Load</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="detail in item.salary" :key="detail.year">
                                                    <td>{{ detail.year }}</td>
                                                    <td>${{ detail.halfcourse }}</td>
                                                    <td>${{ detail.fullcourse }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </p><br />
                            </div>
                            <div>
                                <span class="text-h6">Applying at King's</span><br/>
                                <p>
                                    Consideration of applicants will include an assessment of qualifications, teaching competence, capability, skills and ability, 
                                    and prior relevant experience as well as seniority in cases where applicants are considered relatively equal. 
                                    Applicants should have fluent written and oral communication skills in English.<br /><br />
                                    Please note that Departments/Schools reserve the right to review and modify all course syllabi to ensure alignment with course and program learning outcomes, as necessary, 
                                    to ensure continuity across course sections and academic years, and in order to maintain the integrity of the academic program as a whole.<br /><br />
                                    Please be advised that course section caps may be exceeded from time to time. The College will endeavor to keep increases beyond the cap to a minimum so as not to compromise the pedagogical mode of delivery of the course.<br /><br />
                                    <b><i>All positions are subject to budgetary approval.</i></b><br /><br />
                                    
                                    <i>The College is committed to advancing the Catholic intellectual tradition and welcomes faculty, staff and students from all faiths and backgrounds. <br /><br />
                                    King's University College is committed to Employment Equity and welcomes applications from qualified individuals, including persons of all genders and sexual orientations, persons with disabilities, Indigenous persons, and racialized people.<br /><br />
                                    King's University College is committed to recognizing the dignity and independence of all and seeks to ensure that persons with disabilities have genuine, open and unhindered access to the College's employment opportunities. 
                                    If you require an accommodation during the recruitment process, please contact Human Resources at  <a href="mailto:HR@kings.uwo.ca">HR@kings.uwo.ca</a> or 519-433-3491 for assistance. <br /><br />
                                    All qualified candidates are encouraged to apply, however, Canadian citizens and permanent residents will be given priority.</i>
                                </p>
                            </div><br />
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
export default {
    props: {
        item: {
            required: true
        }
    },
    data(){
        return {
        }
    },
    computed: {
        resolveGeneralTerm(){
            const that = this;
            let term = that.item.strm.slice(-1);
            if(term == "9"){
                var year = that.item.strm[1]+that.item.strm[2];
                var year2 = (parseInt(year)+1).toString();
                var century = (parseInt(that.item.strm[0])-1).toString();
                return "FALL 2"+century+year+"/WINTER 2"+century+year2;
            }else if(term == "5"){
                var year = that.item.strm[1]+that.item.strm[2];
                var century = (parseInt(that.item.strm[0])-1).toString();
                return "SUMMER/INTERSESSION 2"+century+year;
            }
        },
        resolveType(){
            const that = this;
            if(/^CLUSTER/i.test(that.item.type)){
                return true
            }else {
                return false
            }
        },
    },
    methods: {
        resolveTerm(session){
            const that = this;
            let term = that.item.strm.slice(-1);
            var year = that.item.strm[1]+that.item.strm[2];
            var year2 = (parseInt(year)+1).toString();
            var century = (parseInt(that.item.strm[0])-1).toString();
            if(term == "9"){
                if(session == "0" || session == "5" || session == "Q5"){
                    return "FALL2"+century+year+"/WINTER2"+century+year2;
                }else if(session == "1" || session == "6"){
                    return "FALL 2"+century+year
                }else{
                    return "WINTER 2"+century+year2
                }
            }else if(term == "5"){
                return "SUMMER/INTERSESSION 2"+century+year;
            }
        }
    }
}
</script>
<style scoped>
th{
    border: 1px solid #D3D3D3;
}
</style>
<style>
@media print {
    body *:not(.printable, .printable *) {
        display: none;
    }
}
</style>